import Autocomplete from 'components/base/Autocomplete';
import { Margin } from 'components/base/layout-components';
import { get, omitBy } from 'lodash';
import { useEffect, useState } from 'react';

const useFreeInputMenu = ({
  selectedField,
  selectedFilters,
  setSelectedField,
  setSelectedFilterType,
  onCloseMenu,
  setSelectedFilters
}) => {
  const [fieldValue, setFieldValue] = useState(null);
  const [selectedFields, setSelectedFields] = useState([]);

  useEffect(() => {
    if (selectedField) {
      setSelectedFields(
        get(selectedFilters, selectedField, []).map(({ title }) => title)
      );
    }
  }, [selectedField]);

  const freeInputMenu = {
    id: 'fieldOptions',
    header: `Enter ${selectedField}:`,
    actions: [
      {
        title: 'Close',
        isClickToCloseMenu: true,
        onClick: () => {
          setSelectedField(null);
          setSelectedFilterType('field');
        }
      },
      {
        title: 'Add',
        buttonProps: {
          variant: 'contained'
        },
        isClickToCloseAllMenus: true,
        onClick: () => {
          const newFields = fieldValue ? fieldValue.split(',') : [];
          const fieldValues = Array.from(
            new Set(selectedFields.concat(newFields))
          );
          const updatedFilters = {
            ...(selectedFilters || {}),
            ...(selectedFields
              ? {
                  [selectedField]: fieldValues.map(item => ({
                    id: item.id ? item.id.trim() : item.trim(),
                    title: item.name ? item.name.trim() : item.trim(),
                    key: item.key ? item.key.trim() : item.trim()
                  }))
                }
              : {})
          };
          const omittedFilters = omitBy(
            updatedFilters,
            values => values?.length === 0
          );
          setSelectedFilters(omittedFilters);
          setSelectedFilterType(null);
          setFieldValue(null);
          onCloseMenu(2);
        }
      }
    ],
    freeChild: (
      <Margin l='small'>
        <Autocomplete
          width='calc(100% - 1rem)'
          multiple
          placeholder={selectedFields.length ? '' : 'Type in value'}
          options={[]}
          defaultValue={[]}
          value={selectedFields}
          chipInput
          onInputChange={(e, value) => {
            setFieldValue(value);
          }}
          onChange={values => {
            setSelectedFields(values);
          }}
        />
      </Margin>
    )
  };
  return { freeInputMenu };
};

export default useFreeInputMenu;
